import { Card, CardHeader } from "@/components/Card";
import { Chip } from "@/components/Chip";
import {
  formatMonto,
  formatPlazo,
  type CreditoInfo,
} from "@/lib/folio-analysis";

export function CreditoCard({ credito }: { credito: CreditoInfo }) {
  return (
    <Card className="border-emerald-200 bg-gradient-to-br from-emerald-50/60 via-white to-white">
      <CardHeader
        title="Crédito vigente"
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden
          >
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" x2="22" y1="10" y2="10" />
          </svg>
        }
        action={
          <Chip tone="emerald" dot>
            {credito.tipoContrato ?? "Crédito"}
          </Chip>
        }
      />

      <div className="mt-4 grid gap-6 lg:grid-cols-[1fr_auto] lg:items-end">
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-slate-500">
            Monto del crédito
          </p>
          <p className="mt-1 text-3xl font-semibold tracking-tight text-slate-900 tabular-nums">
            {formatMonto(credito.monto, credito.moneda)}
          </p>
        </div>
        <dl className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          <Field label="Plazo" value={formatPlazo(credito.plazo)} />
          <Field
            label="Tasa de interés"
            value={credito.tasa ? credito.tasa.toLowerCase() : "—"}
          />
        </dl>
      </div>

      <div className="mt-6 grid gap-4 border-t border-slate-100 pt-5 sm:grid-cols-2">
        <Field
          label="Acreditante"
          value={credito.acreditante}
          stack
        />
        <Field label="Acreditados" value={credito.acreditados} stack />
      </div>
    </Card>
  );
}

function Field({
  label,
  value,
  stack = false,
}: {
  label: string;
  value: string;
  stack?: boolean;
}) {
  return (
    <div>
      <dt className="text-xs font-medium uppercase tracking-wider text-slate-500">
        {label}
      </dt>
      <dd
        className={`mt-1 text-sm text-slate-800 ${stack ? "leading-relaxed" : "font-medium"}`}
      >
        {value}
      </dd>
    </div>
  );
}
